import React from 'react';

class Projects extends React.Component {
    render() {
        return (
            <div>
                Projects
            </div>
        )
    }
}

export default Projects;